import actionCreatorFactory from 'typescript-fsa';
import { Product } from './products.reducer';
const actionCreator = actionCreatorFactory('Products');

export const updateProductEntities = actionCreator<{
  products: {
    [key: number]: Product;
  };
  appId: number;
}>('ENTITIES_UPDATE');

export const fetchAutoSuggestProduct = actionCreator<{
  productId: number;
  appId: number;
}>('AUTOSUGGEST_FETCH');



// WEBPACK FOOTER //
// ./src/store/Entities/Products/products.actions.ts